import React from 'react';
import {
    IEntity, 
} from '../types';
import { ISelectableOption } from '@fluentui/react/lib/SelectableOption';
import { IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { IDropdownOption } from '@fluentui/react';


export class LookupService {

    public static entitiesToSelectableOptions = <T extends IEntity>(
        entities: T[],
        formatters?: { optionKey?: (entity: T) => string, optionText?: (entity: T) => string }
    ): ISelectableOption[] => {
        return entities ? formatters ?
            entities.map(e => ({ key: formatters.optionKey?.(e) || e.ID, text: formatters.optionText?.(e) || e.Title }))
            :
            entities.map(e => ({ key: e.ID, text: e.Title }))
            :
            [];
    }



    public static entitiesToSelectableOptions2 = <T extends IEntity>(
        entities: T[],
        formatters?: { optionKey?: (entity: T) => string, optionText?: (entity: T) => string }
    ): ISelectableOption[] => {
        return entities.map(e => {
            const option: ISelectableOption = {
                key: formatters?.optionKey?.(e) || e.ID,
                text: formatters?.optionText?.(e) || e.Title || '',
                // Add any other properties you need to assign
            };
            return option;
        });
    }


    public static arrayToDropdownOptions = (arr: string[]): IDropdownOption[] => arr?.map(e => ({ key: e, text: e }));
}
